import React, { useContext } from 'react';
import styled from 'styled-components';
import UIButton from '../ui/button';
import I18nContext from '../../contexts/i18n';
import { useCookieConsentApi } from '../../contexts/cookies';
import SeoLink from '../common/seo_link';
import { useLocation } from 'react-router';
import { SELLER_BANNER_TOTAL_HEIGHT_CSS } from '../site_footer/detail/become_lemonade_seller';

const minimal = new URLSearchParams(window.location.search).get('minimal');

const CookiePopup = () => {
  const i18nSettings = useContext(I18nContext);
  const location = useLocation();
  const locale = i18nSettings.getLocale();
  const { accept } = useCookieConsentApi();
  const shouldOffsetForSellerBanner = location.pathname !== '/seller-application';

  // Arabs suck, don't show this to them.
  if (locale.startsWith('ar')) return null;
  // Hide this on checkout, for better conversion.
  if (location.pathname === '/checkout') return null;

  return (
    <CookiePopupWrapper shouldOffsetForSellerBanner={shouldOffsetForSellerBanner}>
      <div style={{ fontSize: '0.9em' }}>
        <p>
          Cookies help us deliver our services. By continuing to use PIPP,
          you agree to using the cookies described in our
          {' '}<SeoLink to='/cookies'>Cookies Policy</SeoLink>.
        </p>
      </div>
      <ButtonWrapper>
        <UIButton onClick={accept} solid content='Accept' width='96px' />
      </ButtonWrapper>
    </CookiePopupWrapper>
  );
};

const CookiePopupWrapper = styled.div`
  display: ${minimal === 'true' ? 'none' : 'flex'};
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  bottom: ${props => props.shouldOffsetForSellerBanner ? SELLER_BANNER_TOTAL_HEIGHT_CSS : '0'};
  z-index: 999;
  position: fixed;
  color: #000;
  background: rgb(245, 245, 245);
  width: 100%;
  border-top: solid 1px #f2f2f2;
  padding-top: 8px;
  padding-bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 24px 0px 24px;
  }
@media only screen and (max-width: 430px) {
    bottom: 0;
  }
`;

const ButtonWrapper = styled.div`
  padding: 12px 4px;
  align-self: flex-end;
  padding-top: 0;
  @media screen and (min-width: 768px) {
    align-self: flex-end;
    padding: 12px 4px;
  }
`;

export default CookiePopup;
